import PropTypes from 'prop-types';
import React, { useState } from 'react';
import MonthNav from './MonthNav';
import Month from './Month/Month';

const Calendar = ({
  dateMax,
  dateMin,
  first,
  handleDayClick,
  handleDayHover,
  head,
  htmlId,
  index,
  last,
  linkedCalendars,
  monthDropdown,
  selectedEndDate,
  selectedStartDate,
  setHead,
  weekNumbers,
  yearDropdown,
  yearDropdownMaxYear,
  yearDropdownMinYear,
  ...rest
}) => {
  const [thisHead, setThisHead] = useState(() => {
    let initialHead = head;
    if (selectedStartDate?.isValid() && selectedEndDate?.isValid()) {
      initialHead = last ? selectedEndDate : selectedStartDate;
      const diffMonth = selectedEndDate.diff(selectedStartDate, 'months');
      const rangeWithinMonth = diffMonth === 0;
      if (last && rangeWithinMonth) {
        initialHead = selectedEndDate.clone().add('month', 1);
      }
    }
    return initialHead;
  });

  return (
    <>
      <MonthNav
        dateMax={dateMax}
        dateMin={dateMin}
        first={!linkedCalendars || first}
        head={linkedCalendars ? head : thisHead}
        htmlId={htmlId}
        index={index}
        last={!linkedCalendars || last}
        monthDropdown={monthDropdown}
        setHead={linkedCalendars ? setHead : setThisHead}
        yearDropdown={yearDropdown}
        yearDropdownMaxYear={yearDropdownMaxYear}
        yearDropdownMinYear={yearDropdownMinYear}
        {...rest}
      />
      <Month
        dateMax={dateMax}
        dateMin={dateMin}
        handleDayClick={handleDayClick}
        handleDayHover={handleDayHover}
        head={linkedCalendars ? head : thisHead}
        htmlId={htmlId}
        index={index}
        selectedEndDate={selectedEndDate}
        selectedStartDate={selectedStartDate}
        weekNumbers={weekNumbers}
        {...rest}
      />
    </>
  );
};

Calendar.propTypes = {
  dateMax: PropTypes.string.isRequired,
  dateMin: PropTypes.string.isRequired,
  first: PropTypes.bool.isRequired,
  handleDayClick: PropTypes.func.isRequired,
  handleDayHover: PropTypes.func.isRequired,
  head: PropTypes.shape({}).isRequired,
  htmlId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  last: PropTypes.bool.isRequired,
  linkedCalendars: PropTypes.bool.isRequired,
  monthDropdown: PropTypes.bool.isRequired,
  selectedEndDate: PropTypes.shape({
    clone: PropTypes.func,
    diff: PropTypes.func,
    isValid: PropTypes.func,
  }),
  selectedStartDate: PropTypes.shape({
    clone: PropTypes.func,
    diff: PropTypes.func,
    isValid: PropTypes.func,
  }),
  setHead: PropTypes.func.isRequired,
  weekNumbers: PropTypes.bool.isRequired,
  yearDropdown: PropTypes.bool.isRequired,
  yearDropdownMaxYear: PropTypes.number.isRequired,
  yearDropdownMinYear: PropTypes.number.isRequired,
};

Calendar.defaultProps = {
  selectedEndDate: undefined,
  selectedStartDate: undefined,
};

export default Calendar;
